<script setup>
import { computed } from 'vue';
const props = defineProps({
  contacts: Boolean,
  columns: { type: Array, default: () => [] },
});
const stages = computed(() =>
  props.columns.length
    ? props.columns
    : Array.from({ length: 3 }, (_, id) => ({ id }))
);
const sweep =
  'relative overflow-hidden before:pointer-events-none before:absolute before:inset-0 before:z-10 before:-translate-x-full before:animate-skeleton-sweep before:bg-gradient-to-r before:from-transparent before:via-white/40 before:to-transparent dark:before:via-white/5 motion-reduce:before:hidden motion-reduce:before:animate-none';
</script>

<template>
  <div v-if="contacts" aria-hidden="true" :class="sweep">
    <div
      v-for="row in 7"
      :key="row"
      class="flex items-center gap-3 border-b border-n-weak px-4 py-3"
    >
      <div
        class="size-9 shrink-0 rounded-full bg-n-slate-3 dark:bg-n-slate-5"
      />
      <div class="flex min-w-0 flex-1 flex-col gap-2">
        <div class="h-3 w-2/3 rounded bg-n-slate-3 dark:bg-n-slate-5" />
        <div class="h-3 w-full rounded bg-n-slate-3 dark:bg-n-slate-5" />
      </div>
    </div>
  </div>
  <div v-else aria-hidden="true" class="flex min-h-0 gap-3">
    <section
      v-for="(column, index) in stages"
      :key="column.id"
      :class="sweep"
      class="w-72 shrink-0 rounded-xl border border-n-weak bg-n-slate-2 dark:bg-n-solid-2"
    >
      <div class="flex h-12 items-center gap-2 border-b border-n-weak px-3">
        <div class="size-4 rounded bg-n-slate-3 dark:bg-n-slate-5" />
        <span
          v-if="column.name"
          class="min-w-0 flex-1 truncate text-sm font-semibold"
          >{{ column.name }}</span
        >
        <div v-else class="h-3 w-28 rounded bg-n-slate-3 dark:bg-n-slate-5" />
        <div class="ml-auto size-4 rounded bg-n-slate-3 dark:bg-n-slate-5" />
      </div>
      <div class="flex flex-col gap-2 p-2">
        <div
          v-for="card in index % 2 === 0 ? 3 : 2"
          :key="card"
          class="flex flex-col gap-4 rounded-xl border border-n-weak bg-n-solid-2 p-3 dark:bg-n-solid-3"
        >
          <div class="flex items-center gap-2">
            <div
              class="size-8 shrink-0 rounded-full bg-n-slate-3 dark:bg-n-slate-5"
            />
            <div class="h-3 w-2/3 rounded bg-n-slate-3 dark:bg-n-slate-5" />
          </div>
          <div class="h-5 w-16 rounded bg-n-slate-3 dark:bg-n-slate-5" />
          <div class="h-3 w-4/5 rounded bg-n-slate-3 dark:bg-n-slate-5" />
          <div class="h-3 w-1/2 rounded bg-n-slate-3 dark:bg-n-slate-5" />
        </div>
      </div>
    </section>
  </div>
</template>
